require.register("app/restaurant/user/Picker", function(exports, require, module){
  $0
  
});

